import { KatalComponent } from '../../shared/base';

/**
 * @component {kat-accordion} KatalAccordion An expandable content section surrounded by borders. By default it will auto-collapse when an accordion next to it expands.
 * @guideline Do Do use auto-collapse when you have large areas of content inside the accordion and can speed up the time it takes to move between areas. Auto-collapse is best used when a user does not need to compare options within the accordion.
 * @guideline Do Do use remains-expanded when a user needs to compare multiple options or content available to them.
 * @guideline Dont Do not use remains-expanded when large areas of content inside the accordion structure make switching between the areas cumbersome or extend the overall page height 4x or greater than the desktop viewport.
 * @status Production
 * @theme flo
 * @subcomponent ./accordion-header.js
 * @example Simple {"content": "
 * <kat-accordion-header label=\"Section name\"></kat-accordion-header>
 * <kat-accordion-body>
 *   <kat-accordion-content><h5>Title</h5><p>This section is expanded to reveal descriptions and other useful information.</p></kat-accordion-content>
 * </kat-accordion-body>
 * "}
 * @example Complex {"content": "
 * <kat-accordion-header label=\"Section name\" badge-type=\"default\" badge-label=\"New\"></kat-accordion-header>
 * <kat-accordion-body>
 *   <kat-accordion>
 *     <kat-accordion-header label=\"Section name\" badge-type=\"success\" badge-label=\"Success\"></kat-accordion-header>
 *     <kat-accordion-body>
 *       <kat-accordion-content> <h5>Title</h5> <p>This section is expanded to reveal descriptions and other useful information.</p> </kat-accordion-content>
 *     </kat-accordion-body>
 *   </kat-accordion>
 *   <kat-accordion>
 *     <kat-accordion-header label=\"Section name\" badge-type=\"warning\" badge-label=\"Warning\"></kat-accordion-header>
 *     <kat-accordion-body>
 *     <kat-accordion-content> <h5>Title</h5> <p>This section is expanded to reveal descriptions and other useful information.</p> </kat-accordion-content>
 *     </kat-accordion-body>
 *   </kat-accordion>
 * </kat-accordion-body>
 * "}
 * @example WithoutAutoCollapse {"content": "
 * <kat-accordion-header label=\"Section name\" badge-type=\"default\" badge-label=\"New\" remains-expanded=\"true\"></kat-accordion-header>
 * <kat-accordion-body>
 *   <kat-accordion>
 *     <kat-accordion-header label=\"Section name\" badge-type=\"success\" badge-label=\"Success\" remains-expanded=\"true\"></kat-accordion-header>
 *     <kat-accordion-body>
 *       <kat-accordion-content> <h5>Title</h5> <p>This section is expanded to reveal descriptions and other useful information.</p> </kat-accordion-content>
 *     </kat-accordion-body>
 *   </kat-accordion>
 *   <kat-accordion>
 *     <kat-accordion-header label=\"Section name\" badge-type=\"warning\" badge-label=\"Warning\" remains-expanded=\"true\"></kat-accordion-header>
 *     <kat-accordion-body>
 *     <kat-accordion-content> <h5>Title</h5> <p>This section is expanded to reveal descriptions and other useful information.</p> </kat-accordion-content>
 *     </kat-accordion-body>
 *   </kat-accordion>
 * </kat-accordion-body>
 * "}
 */
export class KatalAccordion extends KatalComponent {
  static get observedAttributes() {
    return [];
  }

  constructor() {
    super(KatalAccordion.observedAttributes);
  }

  connectedCallback() {
    super.connectedCallback();
  }
}

KatalComponent.register('kat-accordion', KatalAccordion);
